module.exports = __webpack_public_path__ + "static/img/body-bg.21dccc4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fifa2026/images/body-bg.png
// module id = ge//
// module chunks = 1